import React from "react";
import DashboardStatCard from "../../../components/Cards/Dashboard/DashboardStatCard";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import { IOverAllTeacher, ITypeForTopTen, TypeTeacherOverView } from "../../../types";
import { useHistory } from "react-router-dom";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import CommaSeparator from "../../../components/utils/utility/CommaSeparator/CommaSeparator";
import { getPercentage } from "../Hooks/useStateAdmin";
import { calculateDataUsingDivision } from "../../../utilityFunctions";

type Props = {
  stats: IOverAllTeacher;
  isLoading: boolean;
  averageCriteria: "total" | "active";
  handleClick? :(e:ITypeForTopTen)=>void;
};

const TeacherUsage = ({
  stats,
  isLoading,
  averageCriteria,
  handleClick
}: Props) => {
  return (
    <>
      <div className="bg-primary  py-1 rounded flex-centered mt-4">
        <h3 className="text-white m-0">Teacher Usage</h3>
      </div>
      {isLoading ? (
        <div className="" style={{ height: "300px" }}>
          <DotsSpinner />
        </div>
      ) : (
        <div className="d-flex flex-column">
          <div className="my-2 ml-1">
            <div
              className="d-flex flex-column justify-content-between mt-3 "
              style={{ gap: "10px" }}
            >
              <DashboardStatCard
                title={"Total Teachers"}
                stats={
                  stats?.Total_teacher
                    ? CommaSeparator(stats?.Total_teacher)
                    : "0"
                }
                icon={""}
              />
              <DashboardStatCard
                title={"e-Adhigam Teachers"}
                classes="pointer"
                stats={
                  stats?.EadhigamTeacher &&  stats?.Total_teacher
                    ? `${CommaSeparator(stats?.EadhigamTeacher)} (${calculateDataUsingDivision(
                      +stats?.EadhigamTeacher,
                      averageCriteria === "active" ? +stats?.Total_Active_Teacher : +stats?.Total_teacher
                    )} %)`
                    : "0 (0.00%)"
                }
                icon={""}
              />
              <DashboardStatCard
                title={"Average Weekly Usage (in mins)"}
                stats={
                  stats?.App_Usage && stats?.Total_teacher ? `${(+stats?.App_Usage / +stats?.Total_teacher).toFixed(2)}` : "0"
                }
                icon={""}
                onClick={()=>handleClick({for: "teacher" ,type: "app_usage"})}
              />
              <DashboardStatCard
                title={"Number of Homework Assigned Per Teacher"}
                stats={
                  stats?.Total_assessments && stats?.Total_teacher
                    ? (+stats?.Total_assessments / +stats?.Total_teacher).toFixed(2)
                    : `0`
                }
                icon={""}
              onClick={() => {
                  handleClick({for:"teacher" ,type:"assessments"})
              }}
              />
               {/* <DashboardStatCard
                title={"Average Time Spent on Student Monitoring - ( in mins)"}
                stats={stats?.studentMonitoring && stats?.Total_teacher ? (+stats?.studentMonitoring / +stats?.Total_teacher).toFixed(2)  : "0.00"}
                // stats={stats?.Total_Active_Teacher ? `${CommaSeparator(stats?.Total_Active_Teacher)} (${Math.round(+getPercentage(
                //   String(stats?.Total_Active_Teacher),
                //   String(stats?.Total_teacher)
                // ))}%)` : `0`}
                icon={""}
              /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherUsage;
